var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBusWithPeople = function SvgBusWithPeople(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19 22.75c0-.41.34-.75.75-.75h.5c.41 0 .75.34.75.75v2.5c0 .41-.34.75-.75.75h-.5a.75.75 0 0 1-.75-.75ZM11 22.75c0-.41.34-.75.75-.75h.5c.41 0 .75.34.75.75v2.5c0 .41-.34.75-.75.75h-.5a.75.75 0 0 1-.75-.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    d: "M12 20.95a.6.6 0 0 1 0-.1l.67-3.85h6.66l.66 3.84a.6.6 0 0 1 .01.1v2.46a.6.6 0 0 1-.6.6h-6.8a.6.6 0 0 1-.6-.6v-2.45Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M19 20.5h-6.75"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.25 19H20v2h1.25c.41 0 .75-.34.75-.75v-.5a.75.75 0 0 0-.75-.75ZM10.75 21H13v-2h-2.25a.75.75 0 0 0-.75.75v.5c0 .41.34.75.75.75z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M25.4 11.82c.22.6-.26 1.18-.9 1.18h-4.08a9.08 9.08 0 0 0-.75-1.7 4.8 4.8 0 0 1 1.34-1.79 2.49 2.49 0 0 0 2.9.05c.62.5 1.13 1.28 1.49 2.26zm-7.68-1.36a5.85 5.85 0 0 1 1.56 2.32c.24.6-.24 1.22-.9 1.22h-4.8c-.62 0-1.08-.6-.85-1.17a5.9 5.9 0 0 1 1.56-2.36 2.99 2.99 0 0 0 3.43-.01zM11.6 13a9.2 9.2 0 0 1 .68-1.57 4.81 4.81 0 0 0-1.35-1.88 2.49 2.49 0 0 1-2.9-.03 5.06 5.06 0 0 0-1.53 2.3c-.22.6.26 1.18.9 1.18Zm-.64-5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm12.97 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm-5.92.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBusWithPeople);
export default ForwardRef;